var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-gallery-line",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#74613C",
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M20.825,10H3.175A1.216,1.216,0,0,0,2,11.253v12.16a1.216,1.216,0,0,0,1.175,1.253h17.65A1.216,1.216,0,0,0,22,23.413V11.253A1.216,1.216,0,0,0,20.825,10ZM20.75,23.333H3.25v-12h17.5Z",
    transform: "translate(0 -2.667)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74613C",
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M7.435,17.45a2,2,0,0,0,0-4,2,2,0,0,0,0,4Zm0-3.067a1,1,0,0,1,.942.64,1.12,1.12,0,0,1-.2,1.171.956.956,0,0,1-1.093.243,1.069,1.069,0,0,1-.623-.988A1.037,1.037,0,0,1,7.435,14.383Z",
    transform: "translate(-1.335 -3.817)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74613C",
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M7.158,24.931l3.75-4,1.988,2.12-1.762,1.88h1.25l4.662-4.973,3.925,4.153V22.778l-3.625-3.847a.424.424,0,0,0-.625,0L13.5,22.371,11.2,19.931a.424.424,0,0,0-.625,0l-4.656,5Z",
    transform: "translate(-1.47 -5.598)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74613C",
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M21.14,2.667A.647.647,0,0,0,20.515,2H6.765a.647.647,0,0,0-.625.667v.667h15Z",
    transform: "translate(-1.552)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74613C",
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M21.62,6.667A.647.647,0,0,0,20.995,6H4.745a.647.647,0,0,0-.625.667v.667h17.5Z",
    transform: "translate(-0.795 -1.333)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryBrown);
export default __webpack_public_path__ + "static/media/galleryBrown.6aa0ea62e31f8877e31bd25578cc82ca.svg";
export { ForwardRef as ReactComponent };